import { Button, Form } from 'react-bootstrap';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { getAppPartner } from '../Auth/authSelectors.js';
import { useLangContext } from '../../providers/LangProvider/LangProviderContext.js';
import { Loader } from '../../components/Loader/Loader.jsx';
import { getPartnerUpdatingPayment } from '../Partner/partnerSelectors.js';
import { updatePartnerPaymentAction } from '../Partner/partnerActions.js';
import { PAYMENT_METHODS } from './paymentConstants.js';
import {
    PaymentActionsStyled,
    PaymentFormGridStyled,
    PaymentHintStyled,
    PaymentSectionStyled,
} from './styled/PaymentStyled.js';

function PartnerPayment() {
    const { getLangPath } = useLangContext();
    const dispatch = useDispatch();
    const partnerInfo = useSelector(getAppPartner);
    const updatingPayment = useSelector(getPartnerUpdatingPayment);

    const [paymentType, setPaymentType] = useState(partnerInfo.payment_type);

    useEffect(() => {
        setPaymentType(partnerInfo.payment_type);
    }, [partnerInfo.payment_type]);

    const handleSubmit = useCallback((e) => {
        e.preventDefault();
        dispatch(updatePartnerPaymentAction({
            payment_type: paymentType,
            payment_info: e.target.querySelector('[name=payment_info]').value,
        }));
    }, [paymentType, dispatch]);

    const handleChangePaymentType = useCallback((e) => {
        setPaymentType(e.target.value);
    }, []);

    const currentPaymentMethodConfig = useMemo(() =>
        _.find(PAYMENT_METHODS, { value: paymentType }) || {},
    [paymentType]);

    return <>
        <Loader show={updatingPayment} />
        <PaymentSectionStyled>
            <div className="section-header">
                <div className="section-heading">
                    <span className="section-step">{getLangPath('payment.step_destination')}</span>
                    <h4>{getLangPath('payment.destination_title')}</h4>
                    <p className="section-desc">{getLangPath('payment.destination_desc')}</p>
                </div>
            </div>

            <Form onSubmit={handleSubmit}>
                <PaymentFormGridStyled>
                    <Form.Group>
                        <Form.Label>{getLangPath('payment.payment_type.label')}</Form.Label>
                        <Form.Select name="payment_type" value={paymentType || ''} onChange={handleChangePaymentType}>
                            {PAYMENT_METHODS.map((method) => (
                                <option key={method.name} value={method.value}>
                                    {method.name}
                                </option>
                            ))}
                        </Form.Select>
                        <PaymentHintStyled>{getLangPath('payment.payment_type.hint')}</PaymentHintStyled>
                    </Form.Group>

                    <Form.Group>
                        <Form.Label>{getLangPath('payment.payment_info.label')}</Form.Label>
                        <Form.Control
                            as="textarea"
                            name="payment_info"
                            placeholder={
                                currentPaymentMethodConfig.placeholder
                                    ? getLangPath('payment.payment_info.example', {
                                        example: currentPaymentMethodConfig.placeholder,
                                    })
                                    : ''
                            }
                            defaultValue={partnerInfo.payment_info || ''}
                        />
                        <PaymentHintStyled>{getLangPath('payment.payment_info.hint')}</PaymentHintStyled>
                    </Form.Group>
                </PaymentFormGridStyled>

                <PaymentActionsStyled>
                    <Button variant="primary" type="submit">
                        {getLangPath('payment.save')}
                    </Button>
                </PaymentActionsStyled>
            </Form>
        </PaymentSectionStyled>
    </>;
}

export default PartnerPayment;
